import { createSlice } from '@reduxjs/toolkit';
import { fetchFactCheckApprovalsByCommunityId } from './ApprovalsApi';

const fetchFactCheckApprovalsByCommunityIdSlice = createSlice({
    name: 'fetchFactCheckApprovalsByCommunityId',
    initialState: {
        data: [],
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            // Handle fetchCommunityData cases
            .addCase(fetchFactCheckApprovalsByCommunityId.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchFactCheckApprovalsByCommunityId.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(fetchFactCheckApprovalsByCommunityId.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
    },
});

export default fetchFactCheckApprovalsByCommunityIdSlice.reducer;
